import { combineReducers } from "@reduxjs/toolkit";
import userMgmtSlice from "./userMgmtSlice";
import aboutAndTermsSlice from "./aboutAndTermsSlice";
import activitySlice from "./activitySlice";
import projectSlice from "./projectSlice";
import reportsSlice from "./reportsSlice";
import attendanceReportSlice from "./attendanceReportSlice";
import dashboardSlice from "./dashboardSlice";
import loginSlice from "./loginSlice";
import loaderSlice from "./loader";
import columnsSlice from "./columnsSlice";
import productivitySlice from "./productivitySlice";
import productivityColumnSlice from "./productivityColumnSlice";
import MasterQuantitySlice from "./masterQuantitySlice";
import projectExplorerSlice from "./masterQuantityViewSlice";
import MasterQuantityWorkSlice from "./masterQuantityAddSlice";
import regionSlice from "./regionSlice";
import wingsSlice from "./wingsSlice";
import floorSlice from "./floorSlice";
import UnitsSlice from "./unitSlice";
import WorkAreaSlice from "./workAreaSlice";

const appReducer = combineReducers({
  auth: loginSlice,
  user: userMgmtSlice,
  activity: activitySlice,
  project: projectSlice,
  reports: reportsSlice,
  aboutandTerms: aboutAndTermsSlice,
  attendance: attendanceReportSlice,
  dashboard: dashboardSlice,
  loader: loaderSlice,
  columns: columnsSlice,
  productivity: productivitySlice,
  productivityColumn: productivityColumnSlice,
  masterQuantity: MasterQuantitySlice,
  projectExplorer: projectExplorerSlice,
  masterAddQuantity: MasterQuantityWorkSlice,
  masterregion: regionSlice,
  masterwings: wingsSlice,
  masterfloor: floorSlice,
  masterunits : UnitsSlice,
  workArea: WorkAreaSlice,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    state = undefined; // Clear all state
  }
  return appReducer(state, action);
};

export default rootReducer;
